<template>
    <section class="global-checkout" :class="dark? 'dark' : 'ligth'">
        <Loader :isActive="hasReady" />
        <section class="checkout">
            <section class="breadcrumbs">
                <a href="javascript:void(0);" @click="() => this.$router.back()"><span><i class="pi pi-arrow-left"></i>Voltar</span></a>
            </section>
            <section class="primary-content-checkout">
                <div class="data-checkout">
                    <div class="personal-data-checkout">
                        <div class="step">
                            <h3 class="title-personal-data-checkout"><span class="step">1</span> Dados Pessoais</h3>
                        </div>
                        <div class="inputs-personal-data-checkout">
                            <div class="form-group half">
                                <div class="form-label">
                                    <label>
                                        <span>
                                            Email
                                        </span>
                                    </label>
                                </div>
                                <div class="form-input">
                                    <input type="text" class="form-control" v-model='email' placeholder="seuemail@email.com.br" @change="validateUserEmail()">
                                </div>
                            </div>
                            <div class="form-group half">
                                <div class="form-label">
                                    <label>
                                        <span>
                                            Nome completo
                                        </span>
                                    </label>
                                </div>
                                <div class="form-input">
                                    <input type="text" class="form-control" v-model="name" placeholder="Nome completo">
                                </div>
                            </div>
                            <div class="form-group half">
                                <div class="form-label">
                                    <label>
                                        <span>
                                            CPF
                                        </span>
                                    </label>
                                </div>
                                <div class="form-input">
                                    <input type="text" class="form-control" v-model='socialNumber' placeholder="000.000.000-00" v-mask="'###.###.###-##'">
                                </div>
                            </div>
                            <div class="form-group half">
                                <div class="form-label">
                                    <label>
                                        <span>
                                            Telefone
                                        </span>
                                    </label>
                                </div>
                                <div class="form-input">
                                    <input type="text" class="form-control" v-model='phone' placeholder="(00) 00000-0000">
                                </div>
                            </div>
                            <!-- <div class="form-group col-12">
                                <button class="btn next_step_payment" @click="verifuDataUser()" v-show="!goPayment">Ir para Pagamento</button>
                            </div> -->
                            <div class="loaderUserData" v-show="!hasEmail">
                                <span class="loader"></span>
                                <div class="background-checkout"></div>
                            </div>
                        </div>
                        <div class="step">
                            <h3 class="title-personal-data-checkout"><span class="step">2</span> Dados de Pagamento</h3>
                        </div>
                        <div class="cupon-product-checkout show" ref="paymentOptions">
                            <p @click="(() => this.hasCupom = !this.hasCupom)" class="cupomTitle">Possui cupom de Desconto? Clique aqi!</p>
                            <div class="cupon-discount" v-show="hasCupom">
                                <div class="form-input">
                                    <input type="email" class="form-control" placeholder="Cupom" v-model="cupom">
                                </div>
                                <button class="btn" @click="getDataCupom()">Aplicar</button>
                                <p style="margin:0;" v-show="hasValidCupon">Cupom <strong>{{cupom}}</strong>, aplicado com sucesso!</p>
                            </div>
                        </div>
                        <div class="options_payment-checkout show">
                            <div class="option-payment" :class="paymentMethod == 1 ? 'active' : ''" @click="this.paymentMethod = 1">
                                <div class="option-payment-title">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M9.50023 15H7.01M4 10H21M5 19H19C19.9428 19 20.4142 19 20.7071 18.7071C21 18.4142 21 17.9428 21 17V8C21 7.05719 21 6.58579 20.7071 6.29289C20.4142 6 19.9428 6 19 6H5C4.05719 6 3.58579 6 3.29289 6.29289C3 6.58579 3 7.05719 3 8V17C3 17.9428 3 18.4142 3.29289 18.7071C3.58579 19 4.05719 19 5 19Z" stroke="#33363F" stroke-width="2" stroke-linecap="round"></path>
                                    </svg>
                                    <h4>Cartão de Crédito</h4>
                                </div>
                                <span>Parcele em até 12x sem jutos</span>
                            </div>
                            <div class="option-payment" :class="paymentMethod == 2 ? 'active' : ''" @click="this.paymentMethod = 2">
                                <div class="option-payment-title">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M10.5562 20.4215L8.08076 17.9457C8.48733 17.754 8.86221 17.4914 9.18871 17.1646L11.8743 14.4758L14.5717 17.1763C14.9401 17.5451 15.3701 17.8321 15.8377 18.0277L13.4465 20.4217C12.6507 21.1928 11.3519 21.1928 10.5562 20.4215ZM6.40423 8.58812C6.65186 8.58812 6.90931 8.68294 7.16326 8.91331L10.1479 11.9015L10.1714 11.925L10.1965 11.947C10.2206 11.9681 10.2454 11.9891 10.2709 12.0099C10.2284 12.0469 10.1871 12.0855 10.1469 12.1259C10.1464 12.1264 10.1459 12.127 10.1454 12.1275L7.16348 15.109C6.90946 15.3395 6.65193 15.4344 6.40423 15.4344H5.98853C5.72317 15.4344 5.46869 15.3289 5.28113 15.1412L3.59762 13.4563L3.5972 13.4559C2.80093 12.6599 2.80093 11.3665 3.5972 10.5705L3.59823 10.5695L5.28153 8.88192C5.46914 8.69383 5.72388 8.58812 5.98954 8.58812H6.40423ZM13.4415 3.59817L15.8398 5.99783C15.3714 6.19345 14.9407 6.48071 14.5717 6.8501L11.8743 9.55063L9.19874 6.87189C8.86776 6.52257 8.49157 6.25805 8.08948 6.07009L10.5571 3.59858C10.5572 3.59848 10.5573 3.59838 10.5574 3.59827C11.3566 2.79983 12.6471 2.80161 13.4408 3.59742L13.4415 3.59817ZM13.6008 11.9015L16.6089 8.88975C16.6094 8.88925 16.6099 8.88875 16.6104 8.88825C16.8081 8.69318 17.0832 8.58029 17.3562 8.58029H18.0017C18.2671 8.58029 18.5216 8.68581 18.7092 8.8736L20.4036 10.57C21.1988 11.3661 21.1988 12.6603 20.4036 13.4564L18.7092 15.1528C18.5216 15.3406 18.2671 15.4461 18.0017 15.4461H17.3562C17.083 15.4461 16.8091 15.3332 16.6126 15.1364L13.6008 12.121ZM10.1965 11.947C10.2206 11.9681 10.2454 11.9891 10.2709 12.0099C10.2285 12.0468 10.1872 12.0854 10.1471 12.1258C10.1465 12.1263 10.1459 12.1269 10.1454 12.1275L7.16347 15.109C6.90945 15.3395 6.65193 15.4344 6.40423 15.4344H5.98853C5.72317 15.4344 5.46869 15.3289 5.28113 15.1412L3.59762 13.4563L3.5972 13.4559C2.80093 12.6599 2.80093 11.3665 3.5972 10.5705L3.59823 10.5695L5.28153 8.88192C5.46914 8.69383 5.72388 8.58812 5.98954 8.58812H6.40423C6.65186 8.58812 6.90931 8.68294 7.16325 8.91331L10.1479 11.9015L10.1714 11.925L10.1965 11.947ZM11.8743 9.55063L9.19873 6.87188C8.86776 6.52256 8.49157 6.25805 8.08948 6.07009L10.5571 3.59858C10.5572 3.59848 10.5573 3.59838 10.5574 3.59827C11.3566 2.79983 12.6471 2.80161 13.4408 3.59742L13.4415 3.59817L15.8398 5.99783C15.3714 6.19345 14.9407 6.48071 14.5717 6.8501L11.8743 9.55063ZM10.5562 20.4215L8.08076 17.9457C8.48733 17.754 8.86221 17.4914 9.18871 17.1646L11.8743 14.4758L14.5717 17.1763C14.9401 17.5451 15.3701 17.8321 15.8377 18.0277L13.4465 20.4217C12.6507 21.1928 11.3519 21.1928 10.5562 20.4215Z" stroke="#181818" stroke-width="2"></path>
                                    </svg>
                                    <h4>Pix</h4>
                                </div>
                                <span>Aprovação imediata</span>
                            </div>
                        </div>
                        <div class="billing show">
                            <div class="credit-card-option" v-show="paymentMethod==1">
                                <div class="info-credit-card">
                                    <div class="form-group">
                                        <div class="form-label">
                                            <label>
                                                <span>
                                                    Nome completo do titular
                                                </span>
                                            </label>
                                        </div>
                                        <div class="form-input">
                                            <input type="text" class="form-control" v-model="cardName" placeholder="Nome completo">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="form-label">
                                            <label>
                                                <span>
                                                    Número do cartão
                                                </span>
                                            </label>
                                        </div>
                                        <div class="form-input">
                                            <input type="text" class="form-control" v-model="numberCard" placeholder="1234 456 789 123" v-mask="'#### #### #### ####'" @change="validateCard" />
                                            <small class="error" v-show="isValid==false">Número de cartão Inválido</small>
                                        </div>
                                    </div>
                                    <div class="info-flex">
                                        <div class="form-group">
                                            <div class="form-label">
                                                <label>
                                                    <span>
                                                        Data de vencimento
                                                    </span>
                                                </label>
                                            </div>
                                            <div class="form-input">
                                                <input type="text" class="form-control" v-model="expiredCard" v-mask="'##/##'" placeholder="MM/AA">
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <div class="form-label">
                                                <label>
                                                    <span>
                                                        Código de segurança
                                                    </span>
                                                </label>
                                            </div>
                                            <div class="form-input">
                                                <input type="text" class="form-control" v-model="cardCVV" placeholder="CVC" v-mask="'###'">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="form-label">
                                            <label>
                                                <span>
                                                    Parcelas - {{ installmentCount }}
                                                </span>
                                            </label>
                                        </div>
                                        <div class="form-select2">
                                            <select class="select2-option select2-hidden-accessible" data-select2-id="1" v-model.number="installmentCount" tabindex="-1" aria-hidden="true">
                                                <option :value="installmentCount" data-select2-id="3" v-for="installmentCount in 10" :key="installmentCount">
                                                    {{ installmentCount }}x de R${{ formatDecimals( (value / installmentCount ),2 )}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-credit-card">
                                    <div class="card-box">
                                        <div class="chip">
                                            <svg class="Chip" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 387.8 380.3" style="enable-background:new 0 0 387.8 380.3;" xml:space="preserve">
                                                <defs>
                                                    <linearGradient id="gold-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                                        <stop offset="0%" stop-color="#c79750"></stop>
                                                        <stop offset="20%" stop-color="#e6b964"></stop>
                                                        <stop offset="50%" stop-color=" #f8e889"></stop>
                                                        <stop offset="80%" stop-color=" #deb15f"></stop>
                                                        <stop offset="100%" stop-color=" #dfb461"></stop>
                                                    </linearGradient>
                                                </defs>
                                                <g id="XMLID_4_">
                                                    <path id="XMLID_1_" class="st0" d="M308.8,375.3H79.1C38.2,375.3,5,342.1,5,301.2V79.1C5,38.2,38.2,5,79.1,5h229.7
                                                        c40.9,0,74.1,33.2,74.1,74.1v222.2C382.8,342.1,349.7,375.3,308.8,375.3z"></path>
                                                    <line id="XMLID_2_" class="st0" x1="109.9" y1="5.1" x2="109.9" y2="375.1"></line>
                                                    <line id="XMLID_3_" class="st0" x1="4.9" y1="95.1" x2="109.9" y2="95.1"></line>
                                                    <line id="XMLID_7_" class="st0" x1="4.9" y1="185.1" x2="109.9" y2="185.1"></line>
                                                    <line id="XMLID_8_" class="st0" x1="1.9" y1="275.1" x2="106.9" y2="275.1"></line>
                                                    <line id="XMLID_9_" class="st0" x1="276.9" y1="275.1" x2="381.9" y2="275.1"></line>
                                                    <line id="XMLID_10_" class="st0" x1="274.9" y1="185.1" x2="379.9" y2="185.1"></line>
                                                    <line id="XMLID_11_" class="st0" x1="277.9" y1="95.1" x2="382.9" y2="95.1"></line>
                                                    <g id="XMLID_6_">
                                                        <g id="XMLID_14_">
                                                            <g id="XMLID_32_">
                                                                <path id="XMLID_33_" d="M277.4,90.1h-1c-2.5,0-4.5,2-4.5,4.5v272c0,2.5,2,4.5,4.5,4.5h1c2.5,0,4.5-2,4.5-4.5v-272
                                                                    C281.9,92.1,279.9,90.1,277.4,90.1z"></path>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                        </div>
                                        <div class="name">
                                            {{ cardName == null ? 'Seu nome': cardName}}
                                        </div>

                                        <div class="number">
                                            {{  numberCard == null ? 'XXXX XXXX XXXX XXXX':formatCardNumber(numberCard)}}
                                        </div>
                                        <div class="otherInfo" style="display:flex;">
                                            <div class="date">
                                                {{ expiredCard == null ? 'MM/AA': expirationDate}}
                                            </div>
                                            <div class="cvc">
                                                {{ cardCVV == null ? 'XXX': cardCVV}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="option-boleto" v-show="paymentMethod==2">
                                <div class="info-boleto">
                                    <div class="box-info-boleto">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.02306 3C9.02306 2.44772 8.57534 2 8.02306 2C7.47077 2 7.02306 2.44772 7.02306 3V4H5.25562C4.15105 4 3.25562 4.89543 3.25562 6V11V20C3.25562 21.1046 4.15105 22 5.25562 22H18.3254C19.43 22 20.3254 21.1046 20.3254 20V11V6C20.3254 4.89543 19.43 4 18.3254 4H16.5583V3C16.5583 2.44772 16.1106 2 15.5583 2C15.0061 2 14.5583 2.44772 14.5583 3V4H9.02306V3ZM18.3254 10V6H16.5583V7C16.5583 7.55228 16.1106 8 15.5583 8C15.0061 8 14.5583 7.55228 14.5583 7V6H9.02306V7C9.02306 7.55228 8.57534 8 8.02306 8C7.47077 8 7.02306 7.55228 7.02306 7V6H5.25562V10H18.3254ZM5.25562 12H18.3254V20H5.25562V12Z" fill="#A3A3A3"></path>
                                        </svg>
                                        <h4>Pague até a data de vencimento</h4>
                                    </div>
                                    <div class="box-info-boleto">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4H5V20H1V4ZM19 4H23V20H19V4ZM18 4H16V20H18V4ZM7 4H9V20H7V4ZM14 4H11V20H14V4Z" fill="#A3A3A3"></path>
                                        </svg>
                                        <h4>Pague pela internet ou em qualquer agência bancária</h4>
                                    </div>
                                    <div class="box-info-boleto">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7V11.5858C11 12.1162 11.2107 12.6249 11.5858 13L13.2929 14.7071C13.6834 15.0976 14.3166 15.0976 14.7071 14.7071C15.0976 14.3166 15.0976 13.6834 14.7071 13.2929L13 11.5858V7Z" fill="#A3A3A3"></path>
                                        </svg>
                                        <h4>Aguarde 2 dias úteis para a aprovação do pagamento</h4>
                                    </div>
                                </div>
                                <p>Se o boleto não for pago até a data de vencimento seu pedido será cancelado automaticamente</p>
                            </div>
                            <div class="option-pix" v-show="paymentMethod==3">
                                <div class="info-pix">
                                    <div class="box-info-pix">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M13.6008 12.121C13.5616 12.0818 13.5212 12.0442 13.4798 12.0083C13.5046 11.988 13.5287 11.9676 13.5522 11.947L13.5772 11.925L13.6008 11.9015L16.6089 8.88975C16.6094 8.88925 16.6099 8.88875 16.6104 8.88825C16.8081 8.69318 17.0832 8.58029 17.3562 8.58029H18.0017C18.2671 8.58029 18.5216 8.68581 18.7092 8.8736L20.4036 10.57C21.1988 11.3661 21.1988 12.6603 20.4036 13.4564L18.7092 15.1528C18.5216 15.3406 18.2671 15.4461 18.0017 15.4461H17.3562C17.083 15.4461 16.8091 15.3332 16.6126 15.1364L13.6008 12.121ZM10.1965 11.947C10.2206 11.9681 10.2454 11.9891 10.2709 12.0099C10.2285 12.0468 10.1872 12.0854 10.1471 12.1258C10.1465 12.1263 10.1459 12.1269 10.1454 12.1275L7.16347 15.109C6.90945 15.3395 6.65193 15.4344 6.40423 15.4344H5.98853C5.72317 15.4344 5.46869 15.3289 5.28113 15.1412L3.59762 13.4563L3.5972 13.4559C2.80093 12.6599 2.80093 11.3665 3.5972 10.5705L3.59823 10.5695L5.28153 8.88192C5.46914 8.69383 5.72388 8.58812 5.98954 8.58812H6.40423C6.65186 8.58812 6.90931 8.68294 7.16325 8.91331L10.1479 11.9015L10.1714 11.925L10.1965 11.947ZM11.8743 9.55063L9.19873 6.87188C8.86776 6.52256 8.49157 6.25805 8.08948 6.07009L10.5571 3.59858C10.5572 3.59848 10.5573 3.59838 10.5574 3.59827C11.3566 2.79983 12.6471 2.80161 13.4408 3.59742L13.4415 3.59817L15.8398 5.99783C15.3714 6.19345 14.9407 6.48071 14.5717 6.8501L11.8743 9.55063ZM10.5562 20.4215L8.08076 17.9457C8.48733 17.754 8.86221 17.4914 9.18871 17.1646L11.8743 14.4758L14.5717 17.1763C14.9401 17.5451 15.3701 17.8321 15.8377 18.0277L13.4465 20.4217C12.6507 21.1928 11.3519 21.1928 10.5562 20.4215Z" stroke="#A3A3A3" stroke-width="2"></path>
                                        </svg>
                                        <h4>Pague através do QR Code ou Pix Copia e Cola</h4>
                                    </div>
                                </div>
                                <p>Se o boleto não for pago até a data de vencimento seu pedido será cancelado automaticamente</p>
                            </div>
                        </div>
                        <div class="personal-data-checkout mobile ">
                            <h3 class="title-personal-data-checkout" style="text-align: left;"><span class="step">3</span> Finalização</h3>
                            <div class="billing">
                                <h3 class="title-product-checkout">{{courseCart.comercialName}}</h3>
                                <div class="subtotal-product-checkout">
                                    <span>Total</span>
                                    <h3>R$ {{formatDecimals(value,2)}}</h3>
                                </div>
                                <button
                                    class="button-checkout mobile"
                                    @click="purchase()"
                                    :disabled="!canFinishPurchase"
                                >Finalizar Compra</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="product-checkout desktop hasDataUser show">
                    <h3 class="title-personal-data-checkout" style="text-align: left;"><span class="step">3</span> Finalização</h3>
                    <div class="box-product-checkout">
                        <div class="image-product-checkout">
                            <img :src="courseCart.imageFinalPath2" />
                        </div>
                        <h3 class="title-product-checkout">{{courseCart.comercialName}}</h3>
                        <div class="subtotal-product-checkout">
                            <span>Total</span>
                            <h3>R$ {{formatDecimals(value,2)}}</h3>
                        </div>
                        <button
                            class="button-checkout"
                            @click="purchase"
                            :disabled="!canFinishPurchase"
                        >Finalizar Compra</button>
                    </div>
                </div>
            </section>
        </section>
        <section class="footer">
            <div class="logo-footer">
                <img v-show="dataConfigSite.typeLayout==1" src="@/assets/logo.png" />
                <img v-show="dataConfigSite.typeLayout==2" src="@/assets/logo_white.png" />
            </div>
            <p class="copyright-footer">@Copyright - Weeeduc | 2024 Todos os direitos reservadoss</p>
        </section>
    </section>
    <div class="pa-4 text-center">
        <v-dialog v-model="loadPayment" max-width="320" persistent>
            <v-list class="py-2" color="primary" elevation="12" rounded="lg">
                <v-list-item prepend-icon="mdi-cash-multiple" title="Processando Pagamento...">
                    <template v-slot:prepend>
                        <div class="pe-4">
                            <v-icon color="primary" size="x-large"></v-icon>
                        </div>
                    </template>
                    <template v-slot:append>
                        <v-progress-circular color="primary" indeterminate="disable-shrink" size="16" width="2"></v-progress-circular>
                    </template>
                </v-list-item>
            </v-list>
        </v-dialog>
    </div>
</template>

<style scoped>
@import url('./checkout.css');
</style>

<script>
import Loader from '@/components/Loader/loader.vue';
import ApiPayment from '@/utils/Weflix/Website/payment';
import { mapState, mapActions } from 'vuex';
import api from '@/utils/website';
import apiCep from '@/utils/cep'

export default {
    data() {
        return {
            hasCupom: false,
            hasReady: false,
            typeLayout: 1,
            hidePassword: false,
            isValid: null,
            dialog: false,
            loadPayment: false,
            dataConfigSite: [],
            dataCouseCart: null,
            nameCard: null,
            numberCard: null,
            expiredCard: null,
            ccvCard: null,
            expiryMonthCard: 'string',
            expiryYearCard: 'string',
            installmentCount: 1,
            hasEmail: true,
            goPayment: false,
            //User Data
            email: null,
            name: null,
            password: '',
            rePassword: '',
            socialNumber: null,
            phone: null,
            // Campos removidos do formulário:
            // idNumber: null,
            // country: null,
            // county: null,
            // city: null,
            // address: null,
            // addressNumber: null,
            // addressComplement: null,
            // postcode: null,
            hasDataUser: false,
            //Company Data
            idCompany: 0,
            idCourse: 0,
            courseName: 'string',
            courseCode: 'string',
            courseQty: 1,
            //Payment Data
            paymentMethod: 1,
            cupom: null,
            hasValidCupon: null,
            discount: 0,
            dueDate: 'string',
            value: null,
            expires_in: 86400,
            installmentCount: 1,
            cardName: null,
            cardCVV: null,
            states: [
                "Acre",
                "Alagoas",
                "Amapá",
                "Amazonas",
                "Bahia",
                "Ceará",
                "Distrito Federal",
                "Espírito Santo",
                "Goiás",
                "Maranhão",
                "Mato Grosso",
                "Mato Grosso do Sul",
                "Minas Gerais",
                "Pará",
                "Paraíba",
                "Paraná",
                "Pernambuco",
                "Piauí",
                "Rio de Janeiro",
                "Rio Grande do Norte",
                "Rio Grande do Sul",
                "Rondônia",
                "Roraima",
                "Santa Catarina",
                "São Paulo",
                "Sergipe",
                "Tocantins"
            ],
            estados: {
                "Acre": "AC",
                "Alagoas": "AL",
                "Amapá": "AP",
                "Amazonas": "AM",
                "Bahia": "BA",
                "Ceará": "CE",
                "Distrito Federal": "DF",
                "Espírito Santo": "ES",
                "Goiás": "GO",
                "Maranhão": "MA",
                "Mato Grosso": "MT",
                "Mato Grosso do Sul": "MS",
                "Minas Gerais": "MG",
                "Pará": "PA",
                "Paraíba": "PB",
                "Paraná": "PR",
                "Pernambuco": "PE",
                "Piauí": "PI",
                "Rio de Janeiro": "RJ",
                "Rio Grande do Norte": "RN",
                "Rio Grande do Sul": "RS",
                "Rondônia": "RO",
                "Roraima": "RR",
                "Santa Catarina": "SC",
                "São Paulo": "SP",
                "Sergipe": "SE",
                "Tocantins": "TO"
            },
        }
    },
    computed: {
        ...mapState(['courseCart', 'dataWebsite', 'dark']),
        expirationDate() {
            let value = this.expiredCard ? this.expiredCard.replace(/[^\d]/g, '') : '';
            if (value.length > 2) {
                value = value.slice(0, 2) + '/' + value.slice(2);
            }
            return value.slice(0, 5);
        },
        canFinishPurchase() {
            // Dados do usuário preenchidos
            const userOk = !!(this.email && this.name && this.socialNumber && this.phone);

            // Dados de pagamento preenchidos conforme método
            if (this.paymentMethod == 1) {
                // Cartão de crédito
                return userOk &&
                    this.cardName &&
                    this.numberCard &&
                    this.expiredCard &&
                    this.cardCVV &&
                    this.isValid === true;
            } else if (this.paymentMethod == 2 || this.paymentMethod == 3) {
                // Boleto ou Pix
                return userOk;
            }
            return false;
        }
    },
    components: {
        Loader
    },
    methods: {
        ...mapActions(['storeDataPayment', 'storeTypePayment', 'storeDataUserPayment']),
        validateCard() {
            this.isValid = this.luhnCheck(this.numberCard);
        },
        luhnCheck(cardNumber) {
            const cleanNumber = cardNumber.replace(/\D/g, '').replace(' ', '');
            let sum = 0;
            let shouldDouble = false;
            for (let i = cleanNumber.length - 1; i >= 0; i--) {
                let digit = parseInt(cleanNumber.charAt(i), 10);
                if (shouldDouble) {
                    digit *= 2;
                    if (digit > 9) {
                        digit -= 9;
                    }
                }
                sum += digit;
                shouldDouble = !shouldDouble;
            }
            return sum % 10 === 0;
        },
        async getDataSite() {
            const site = this.getCurrentUrlWithoutTrailingSlash();
            try {
                const response = await api.getDataWebsite(site);
                this.hasReady = true;
                this.dataConfigSite = response;
                this.typeLayout = response.typeLayout;
                const styleElement = document.createElement('style');
                styleElement.type = 'text/css';
                styleElement.appendChild(document.createTextNode(response.css));
                document.head.appendChild(styleElement);
                const scriptElement = document.createElement('script');
                scriptElement.type = 'text/javascript';
                scriptElement.appendChild(document.createTextNode(response.javascript));
                document.body.appendChild(scriptElement);
            } catch (error) {
                console.error('Erro ao gerar dados do site');
            }
        },
        formatDecimals(value, decimals) {
            if (isNaN(value)) {
                return "Invalid number";
            }
            return Number(value).toLocaleString('pt-BR', {
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals
            });
        },
        formatCardNumber(cardNumber) {
            const formatted = cardNumber.toString().replace(/(\d{4})(?=\d)/g, '$1 ');
            return formatted;
        },
        async purchase() {
            this.loadPayment = true;
            if (!this.canFinishPurchase) {
                alert('Preencha todos os dados obrigatórios para finalizar a compra.');
                this.loadPayment = false;
                return;
            }
            if (this.paymentMethod == 1 && (this.expiredCard == null || this.numberCard == null)) {
                alert('Por Favor preencha os dados do cartão de Crédito');
                this.loadPayment = false;
                return;
            }
            let paymentMethod = null;
            let month = null;
            let year = null;
            let str = null;
            let trimmedStr = null;
            
            if (this.paymentMethod == 1) {
                let dateString = this.expiredCard;
                let parts = dateString ? dateString.split('/') : [];
                month = parts[0];
                year = parts[1];
            }
            const obj = {
                user: {
                    name: this.name ? this.name.replace(/[^\w\s]/gi, '') : '',
                    email: this.email,
                    password: this.password ? this.password.replace(/[^\w\s]/gi, '') : '',
                    phone: this.phone ? this.phone.replace(/[^\w\s]/gi, '') : '',
                    socialNumber: this.socialNumber ? this.socialNumber.replace(/[^\w\s]/gi, '') : '',
                },
                simpleRequest: {
                    installments: this.installmentCount,
                    cupomCode: (this.cupomCode || "").replace(/[^\w\s]/gi, ''),
                    typePayment: this.paymentMethod,
                    id: this.courseCart.id
                },
                url: 'https://homolog.weeduc.com.br'
            };
            if (this.paymentMethod === 1) {
                obj.simpleRequest.card = {
                    number:this.numberCard ? this.numberCard.replace(/\s+/g, '') : '',
                    holder_name: this.cardName,
                    exp_month: month,
                    exp_year: year,
                    cvv: this.cardCVV
                };
            }
            this.storeDataUserPayment({ dataUserPayment: obj })
            try {
                const response = await api.purchaseWeeduc(obj);
                console.debug(response)
                this.storeDataPayment({ dataPayment: response });
                this.storeTypePayment({ typePayment: paymentMethod });
                this.$router.push({ name: 'Sucesso' });
            } catch (error) {
                console.error(error);
            }
        },
        async validateUserEmail() {
            if (this.email) {
                this.hasEmail = false;
                const url = this.getCurrentUrlWithoutTrailingSlash();
                try {
                    const response = await api.getDataUserEamil(this.email, url);
                    if (response.status == 401) {
                        this.hasEmail = true;
                    } else {
                        setTimeout(() => {
                            this.hasEmail = true;
                        }, 1000);
                        this.hasDataUser = true;
                        this.hidePassword = true;
                        this.email = response.email;
                        this.name = response.name;
                        this.socialNumber = response.socialNumber;
                        this.phone = response.phone;
                    }
                } catch (error) {
                    console.error(error);
                    this.hasEmail = true;
                }
            }
        },
        verifuDataUser() {
            if (
                this.email &&
                this.name &&
                this.socialNumber &&
                this.phone
            ) {
                this.goPayment = true;
                this.scrollToElement();
            } else {
                alert('Preencha todos os campos');
            }
        },
        scrollToElement() {
            this.$refs.paymentOptions.scrollIntoView({ behavior: 'smooth', block: 'start' });
        },
        async getDataCupom() {
            if (this.cupom) {
                try {
                    const response = await api.getDataCupom(this.cupom, this.courseCart.company.id);
                    this.hasValidCupon = true;
                    this.discount = response.discount;
                    this.value = this.value - ((this.value * this.discount) / 100);
                } catch (error) {
                    console.error(error)
                }
            }
        },
        getCodigoEstado(nomeEstado) {
            const estado = nomeEstado.trim().toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
            if (this.estados.hasOwnProperty(estado)) {
                return this.estados[estado];
            } else {
                return "Estado não encontrado";
            }
        },
        //Tag Manager
        loadDataTagManager() {
            (function (w, d, s, l, i) {
                w[l] = w[l] || []; w[l].push({
                    'gtm.start':
                        new Date().getTime(), event: 'gtm.js'
                }); var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                        'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', this.dataWebsite.tagManagerCode);
        },
        //Tag Manager Payment
        loadDataTagManagerPayment() {
            dataLayer.push({
                event: "begin_checkout",
                ecommerce: {
                    items: [{
                        'item_name': this.courseCart.comercialName,
                        'item_id': this.courseCart.id,
                        'price': this.courseCart.price,
                        'quantity': 1,
                        'index': 1
                    }]
                }
            });
        },
        //Google Analytics
        addGtagScript() {
            const script = document.createElement('script');
            script.async = true;
            script.src = "https://www.googletagmanager.com/gtag/js?id=" + this.dataWebsite.googleAnalyticsCode;
            document.head.appendChild(script);
        },
        initGtag() {
            window.dataLayer = window.dataLayer || [];
            function gtag() { dataLayer.push(arguments); }
            gtag('js', new Date());
            gtag('config', this.dataWebsite.googleAnalyticsCode);
        },
        //Facebook Pixel
        loadDataFacebbokPixel() {
            !function (f, b, e, v, n, t, s) {
                if (f.fbq) return; n = f.fbq = function () { n.callMethod ?
                    n.callMethod.apply(n, arguments) : n.queue.push(arguments) };
                if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
                n.queue = []; t = b.createElement(e); t.async = !0;
                t.src = v; s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s)
            }(window, document, 'script',
                'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', this.dataWebsite.facebookPixelCode);
            fbq('track', 'PageView');
        },
        //Facebook Pixel Payment
        loadFacebookPixelPayment() {
            fbq('track', 'AddToCart');
            fbq('track', 'InitiateCheckout');
        },
        //Google Ads Pixel
        addGadsScript() {
            const script = document.createElement('script');
            script.async = true;
            script.src = "https://www.googletagmanager.com/gtag/js?id=" + this.dataWebsite.googleAdsCode;
            document.head.appendChild(script);
        },
        initGads() {
            window.dataLayer = window.dataLayer || [];
            function gtag() { dataLayer.push(arguments); }
            gtag('js', new Date());
            gtag('config', this.dataWebsite.googleAdsCode);
        },
        // completeCep removido pois não há mais campo de CEP
        getCurrentUrlWithoutTrailingSlash() {
            let url = 'https://homolog.weeduc.com.br'
            if (window.location.href == 'http://localhost:8080/checkout') {
                url = 'https://homolog.weeduc.com.br'
            } else {
                url = window.location.href;
            }
            return { 'url': url }
        }
    },
    mounted() {
        this.loadDataTagManager();
        this.loadDataTagManagerPayment();
        this.addGtagScript();
        this.initGtag();
        this.loadDataFacebbokPixel();
        this.loadFacebookPixelPayment();
        this.addGadsScript();
        this.initGads();
    },
    created() {
        if (this.courseCart == null) {
            this.$router.push({ name: 'Home' });
            return
        }
        this.getDataSite();
        this.value = this.courseCart.price - this.courseCart.discount;
        let today = new Date();
        // Formata a data para dd/mm/aaaa
        let dd = String(today.getDate()).padStart(2, '0');
        let mm = String(today.getMonth() + 1).padStart(2, '0'); // Janeiro é 0!
        let yyyy = today.getFullYear();
        // Monta a data no formato desejado
        this.dueDate = `${yyyy}-${mm}-${dd}`;
    },
    watch: {
        dialog(val) {
            if (!val) return
            setTimeout(() => (this.dialog = false), 4000)
        },
        installmentCount(newVal) {
            console.log('Número de parcelas atualizado:', newVal);
        }
    },
}
</script>
